import { render } from "./ImportProductosBonificacion.vue?vue&type=template&id=5bb98f94"
import script from "./ImportProductosBonificacion.vue?vue&type=script&lang=js"
export * from "./ImportProductosBonificacion.vue?vue&type=script&lang=js"

import "./ImportProductosBonificacion.vue?vue&type=style&index=0&id=5bb98f94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__